var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"mt-13"},[_c('v-row',{attrs:{"align":"stretch"}},[_c('v-col',{staticClass:"d-flex flex-column",attrs:{"cols":"12"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('heading.errorPage.title')))]),_c('span',[_vm._v(_vm._s(_vm.$t('heading.errorPage.subtitle')))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }